
/* injects from baggage-loader */

export const keyBoxImg = [
    {
        name: 'tetra-blue-key',
        src: require('_images/tetra/keys/blue-key.png'),
        key: true
    },
    {
        name: 'tetra-red-key',
        src: require('_images/tetra/keys/red-key.png'),
        key: true
    },
    {
        name: 'tetra-yellow-key',
        src: require('_images/tetra/keys/yellow-key.png'),
        key: true
    },
    {
        name: 'blue-key-taken',
        src: require('_images/tetra/keys/blue-key-taken.png'),
        key: false
    },
    {
        name: 'red-key-taken',
        src: require('_images/tetra/keys/red-key-taken.png'),
        key: false
    },
    {
        name: 'yellow-key-taken',
        src: require('_images/tetra/keys/yellow-key-taken.png'),
        key: false
    }
]

export const keyPNG = [
    {
        name: "blue-key-png",
        src: require('_images/tetra/blue-key-png.png'),
        width: 42,
        height: 146,
        visible: true
    },
    {
        name: "red-key-png",
        src: require('_images/tetra/red-key-png.png'),
        width: 42,
        height: 146,
        visible: true
    },
    {
        name: "yellow-key-png",
        src: require('_images/tetra/yellow-key-png.png'),
        width: 42,
        height: 146,
        visible: true 
    },
    {
        name: "blue-key-tetra",
        src: require('_images/tetra/blue-key-tetra.png'),
        width: 189,
        height: 131,
        visible: false 
    },
    {
        name: "red-key-tetra",
        src: require('_images/tetra/red-key-tetra.png'),
        width: 205,
        height: 120,
        visible: false 
    },
    {
        name: "yellow-key-tetra",
        src: require('_images/tetra/yellow-key-tetra.png'),
        width: 85,
        height: 204,
        visible: false
    }
]


// WEBPACK FOOTER //
// ./src/app/pages/tetraedro/tetraedro.const.js